import { render, staticRenderFns } from "./ReviewsCasa.vue?vue&type=template&id=0dfbb318&scoped=true"
import script from "./ReviewsCasa.vue?vue&type=script&lang=js"
export * from "./ReviewsCasa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfbb318",
  null
  
)

export default component.exports